import React from 'react';
import { showNotification } from 'react-admin';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { userActivateDeactivate } from './userReduxActions';

class ActivateDeactivateButton extends React.Component {
  state = {
    loading: false,
  };

  handleClick = () => {
    const { record, activateDeactivate } = this.props;
    activateDeactivate(record.id, record);
  };

  render() {
    const { record } = this.props;
    const { loading } = this.state;
    return (
      <Button variant="flat" color="primary" onClick={this.handleClick} disabled={loading}>
        {record.is_active ? 'Deactivate' : 'Activate'}
      </Button>
    );
  }
}

export default connect(
  null,
  {
    showNotification,
    activateDeactivate: userActivateDeactivate,
  },
)(ActivateDeactivateButton);



// WEBPACK FOOTER //
// ./src/resources/users/ActivateDeactivateButton.jsx